import queries from '@apis/queries';
import { StampHistoryRow } from '@models/stamp';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useStampHistories(shopId: string) {
  const [page, setPage] = useState<number>(0);
  const { data, status } = useQuery(queries.stamps.history(shopId, { page, size: 20 }));
  const [histories, setHistories] = useState<StampHistoryRow[]>([]);
  const fetchNext = () => {
    if (status !== 'pending' && !data?.slice.last) {
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (data) {
      setHistories((prev) => [...prev, ...data.content]);
    }
  }, [data]);
  return {
    histories, fetchNext,
  };
}

export default useStampHistories;
